// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__VMRlg","rootSuccess":"CompleteLink_rootSuccess__6y2f1","rootFailure":"CompleteLink_rootFailure__18sGr","isDisabled":"CompleteLink_isDisabled__2Jtn2"};